// TMOS Measurement Service
// Date: January 13, 2026
// Purpose: Frontend service for creating KPI measurements (actual values)

import api from './api';

export interface CreateMeasurementRequest {
  kpi_id: string;
  measurement_date: string; // YYYY-MM-DD
  value: number;
  target_value?: number;
  plan_id?: string;
  plan_objective_id?: string;
  plan_objective_detail_id?: string;
  business_hierarchy_id?: string;
  functional_hierarchy_id?: string;
  geographic_hierarchy_id?: string;
  rollup_method_override?: 'SUM' | 'AVERAGE' | 'MAX' | 'MIN' | 'MANUAL' | 'NONE';
  data_source?: 'MANUAL' | 'API' | 'EXCEL' | 'DATA_LAKE';
}

export interface BulkMeasurementRequest {
  measurements: CreateMeasurementRequest[];
}

export interface Measurement {
  id: string;
  kpi_id: string;
  measurement_date: string;
  value: number;
  target_value?: number | null;
  plan_id?: string | null;
  plan_objective_id?: string | null;
  plan_objective_detail_id?: string | null;
  business_hierarchy_id?: string | null;
  functional_hierarchy_id?: string | null;
  geographic_hierarchy_id?: string | null;
  rollup_method_override?: string | null;
  data_source: string;
  created_at: string;
  updated_at: string;
}

export const measurementService = {
  /**
   * Create a single measurement
   */
  async createMeasurement(data: CreateMeasurementRequest): Promise<Measurement> {
    const response = await api.post<{ success: boolean; message: string; data: Measurement }>(
      '/business-performance/measurements',
      data
    );
    return response.data.data;
  },

  /**
   * Bulk create measurements
   */
  async bulkCreateMeasurements(data: BulkMeasurementRequest): Promise<{ measurements: Measurement[]; count: number }> {
    const response = await api.post<{ success: boolean; message: string; data: Measurement[]; count: number }>(
      '/business-performance/measurements/bulk',
      data
    );
    return {
      measurements: response.data.data,
      count: response.data.count
    };
  }
};

